var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"2a550df6ed04108148f604d1d17c15a41476a499"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hem-com@hem-design-studio"]={id:"2a550df6ed04108148f604d1d17c15a41476a499"};
      